import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import categoryService from '../api/categoryService';
import demandService from '../api/demandsService';
import companyService from '../api/companiesService';
import { getAllLocalizations } from '../api/localizationService';
import '../App.css';
import { decodeTokenJsonUser } from '../shared/helpers/jwtDecoder';
import CategoriesScreen from './categories/CategoriesScreen';
import CompaniesScreen from './companies/CompaniesScreen';
import EmailScreen from './email/EmailScreen';
import WhatsAppTable from './whatsapp/WhatsAppTable';
import DemandScreen from './demand/DemandScreen';
import JobcoinsPacketsScreen from './financial/JobcoinsPackets/JobcoinsPacketsScreen';
import CreateGoldenDemand from './golden-demands/CreateGoldenDemand';
import GoldenDemandsScreen from './golden-demands/GoldenDemandsScreen';
import HomeScreen from './home/HomeScreen';
import MarketingCampaignsScreen from './marketing-campaigns/MarketingCampaignsScreen';
import NotFoundScreen from './not-found/NotFoundScreen';
import QuestionsScreen from './questions/QuestionsScreen';
import UsersScreen from './users/UserScreen';
import WhatsAppScreenForm from './whatsapp/WhatsAppScreenForm';
import WhatsAppScreen from './whatsapp/WhatsAppScreen';
import ReviewScreen from './review/ReviewScreen';


class Routes extends Component {
    componentDidMount() {
        getAllLocalizations();
        companyService.getAllCompanies();
        categoryService.getAllCategories();
        demandService.getAllDemands();
    }

    render() {
        const { role } = this.props.loggedUser;
        if (role === 'COMPANY') {
            return (
                <main style={{ flexGrow: 1, backgroundColor: '#eaeaea' }}>
                    <Switch>
                        <Route path="/" exact component={GoldenDemandsScreen} />
                        <Route path="/goldendemand/create" exact component={CreateGoldenDemand} />
                        <Route path="*" exact component={NotFoundScreen} />
                    </Switch>
                </main>
            );
        }

        return (
            <main style={{ flexGrow: 1, backgroundColor: '#eaeaea' }}>
                <Switch>
                    <Route path="/" exact component={HomeScreen} />
                    <Route path="/categories" component={CategoriesScreen} />
                    <Route path="/users" component={UsersScreen} />
                    <Route path="/financial/jobcoins" exact component={JobcoinsPacketsScreen} />
                    <Route path="/questions" component={QuestionsScreen} />
                    <Route path="/companies" component={CompaniesScreen} />
                    <Route path="/email" component={EmailScreen} />
                    <Route path="/whatsapp" component={WhatsAppScreenForm} />
                    <Route path="/whatsappTable" component={WhatsAppScreen} />
                    <Route path="/reviews" component={ReviewScreen} />
                    <Route path="/demand" component={DemandScreen} />
                    <Route path="/marketing-campaigns" component={MarketingCampaignsScreen} />
                    <Route path="*" exact component={NotFoundScreen} />
                </Switch>
            </main>
        );
    }
}


const mapStateToProps = ({ authState }) => ({
    loggedUser: decodeTokenJsonUser(authState.loggedUser)
});

export default connect(mapStateToProps)(Routes);